<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <navbar />
  <div class="register-container auth-container">
    <el-card class="register-card auth-card" shadow="always">
      <template #header>
        <div class="card-header auth-header">
          <img src="../assets/logo2.jpeg" alt="Wedoomotion" class="auth-logo" />
          <h2>S'inscrire sur Wedoomotion</h2>
          <p class="auth-subtitle">Rejoignez la communauté en quelques secondes</p>
        </div>
      </template>

      <el-form label-position="top" @submit.prevent>
        <el-form-item label="Nom d'utilisateur">
          <el-input
            v-model="username"
            placeholder="Choisissez un nom d'utilisateur"
            :prefix-icon="User"
          />
        </el-form-item>

        <el-form-item label="E-mail">
          <el-input
            v-model="email"
            type="email"
            placeholder="Votre adresse e-mail"
            :prefix-icon="Message"
          />
        </el-form-item>

        <el-form-item label="Mot de passe">
          <el-input
            v-model="password"
            type="password"
            placeholder="8 caractères min., majuscule, chiffre, symbole"
            :prefix-icon="Lock"
            show-password
          />
        </el-form-item>

        <el-form-item label="Confirmez votre mot de passe">
          <el-input
            v-model="confirmPassword"
            type="password"
            placeholder="Répétez votre mot de passe"
            :prefix-icon="Lock"
            show-password
          />
        </el-form-item>

        <el-form-item label="Photo de profil (facultative)">
          <el-upload
            class="avatar-uploader"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleFileChange"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-checkbox v-model="termsAccepted" class="terms-checkbox">
            J'accepte les
            <router-link to="/cgu" target="_blank">conditions générales d'utilisation</router-link>
            et la
            <router-link to="/confidentialite" target="_blank">politique de confidentialité</router-link>
          </el-checkbox>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="full-width" @click="register">
            S'inscrire
          </el-button>
        </el-form-item>
      </el-form>

      <el-alert
        v-if="error"
        :title="error"
        type="error"
        show-icon
        :closable="false"
        class="register-alert"
      />

      <div class="login-link">
        <span>Déjà un compte ?</span>
        <router-link to="/login">
          <el-button link type="primary">Se connecter</el-button>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import '@/styles/auth.css'
import api from '@/api';
import Navbar from '@/components/Navbar.vue'
import { User, Message, Lock, Plus } from '@element-plus/icons-vue'

export default {
  components: {
    Navbar,
    Plus,
  },

  data() {
    return {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      profilePicture: null,
      imageUrl: '',
      termsAccepted: false,
      error: null,
    }
  },

  computed: {
    User() {
      return User
    },
    Message() {
      return Message
    },
    Lock() {
      return Lock
    },
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },

  methods: {
    handleFileChange(file) {
      this.profilePicture = file.raw
      this.imageUrl = URL.createObjectURL(file.raw)
    },

    register() {
      if (!this.username.trim()) {
        this.error = "Veuillez saisir un nom d'utilisateur"
        return
      }

      if (!this.email.trim() || !this.isValidEmail(this.email)) {
        this.error = 'Veuillez saisir une adresse e-mail valide'
        return
      }

      const isPasswordComplex = (password) => {
        // Minuscule, majuscule, chiffre et symbole (tout caractère qui n'est ni lettre, ni chiffre, ni espace),
        // sans espace ; les lettres accentuées sont acceptées
        const passwordRegex =
          /^(?=.*\p{Ll})(?=.*\p{Lu})(?=.*\d)(?=.*[^\p{L}\d\s])\S{8,}$/u
        return passwordRegex.test(password)
      }

      if (!isPasswordComplex(this.password)) {
        this.error =
          'Le mot de passe doit contenir au moins 8 caractères, une lettre minuscule et une majuscule, un chiffre, et un caractère spécial !'
        return
      }

      if (this.password !== this.confirmPassword) {
        this.error = 'Les mots de passe ne correspondent pas'
        return
      }

      // Consentement RGPD : la date d'acceptation est enregistrée par l'API
      if (!this.termsAccepted) {
        this.error = 'Vous devez accepter les CGU et la politique de confidentialité'
        return
      }

      const formData = new FormData()
      formData.append('username', this.username)
      formData.append('email', this.email)
      formData.append('password', this.password)
      formData.append('termsAccepted', 'true')

      if (this.profilePicture) {
        formData.append('profilePicture', this.profilePicture)
      } else {
        formData.append('profilePicture', 'photo.jpg')
      }

      api
        .post('/session/register', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          sessionStorage.setItem('userEmail', this.email)
          this.$router.push('/Validation')
        })
        .catch((error) => {
          if (error.response?.data?.message) {
            this.error = error.response.data.message
          } else {
            this.error =
              "Inscription échouée. Vérifiez vos informations et réessayez."
          }
        })
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    },
  },
}
</script>

<style scoped>
.full-width {
  width: 100%;
}

.register-alert {
  margin-bottom: 16px;
}

.login-link {
  text-align: center;
  margin-top: 8px;
  color: #606266;
}

.login-link span {
  margin-right: 4px;
}

/* Case CGU : le libellé (avec ses liens) peut passer à la ligne */
.terms-checkbox {
  white-space: normal;
  height: auto;
  align-items: flex-start;
  line-height: 1.5;
}

.terms-checkbox a {
  color: var(--el-color-primary);
}

/* Upload d'avatar */
.avatar-uploader {
  display: flex;
  justify-content: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
}
</style>
